import { ReactNode } from "react";
import { toast } from "react-toastify";

import { Icon } from "../icon";

type Props = {
  badge?: ReactNode;
  details?: ReactNode;
  message: ReactNode;
};

export const SuccessToast = ({ message, details, badge }: Props) => {
  return (
    <div className="flex max-w-[300px] items-start gap-x-2.5">
      <Icon className="size-9" name="verifiedCheck" />
      <div className="flex flex-col gap-y-0.5">
        <h5 className="line-clamp-3 overflow-hidden font-medium">{message}</h5>

        {details && (
          <p className="text-pickledBluewood line-clamp-4 text-sm">{details}</p>
        )}

        {badge && (
          <span className="bg-basketBallOrange/10 text-basketBallOrange mt-2 inline-flex rounded-sm px-2.5 py-[5px] text-sm shadow-sm">
            {badge}
          </span>
        )}
      </div>
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const notifySuccess = (props: Props) => {
  return toast.success(<SuccessToast {...props} />, {
    autoClose: 1000000000,
    hideProgressBar: true,
    closeButton: false,
  });
};
